import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Home from '../../models/Home';
import Loading from '../common/Loading';
import { MapGoogle } from '@homeexchange/design';
import Analytics from '../../utils/analytics';
import { isCollectionPage } from '../../utils/url';

export const HomeMap = ({ home }) => {
    const [loading, setLoading] = useState(!home);

    useEffect(() => {
        if (home) {
            setLoading(false);
        }
    }, [home]);

    return loading ? (
        <Loading />
    ) : (
        <>
            <div style={{ height: '400px', width: '100%' }}>
                <MapGoogle
                    apiKey={process.env.GOOGLE_MAPS_API_KEY}
                    mapId={process.env.GOOGLE_MAPS_MAP_ID}
                    defaultCenter={{
                        lat: home.get('location')?.latitude,
                        lng: home.get('location')?.longitude
                    }}
                    zoom={14}
                    circleLayer={{
                        center: {
                            lat: home.get('location')?.latitude,
                            lng: home.get('location')?.longitude
                        },
                        radius: 500,
                        strokeColor: isCollectionPage() ? '#bea18d' : '#f7a800',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: isCollectionPage() ? '#bea18d' : '#f7a800',
                        fillOpacity: 0.2
                    }}
                    onMapLoad={() => {
                        Analytics.trackGTM('map', {
                            event_data: {
                                action: 'map_open',
                                text: 'map_open',
                                area: 'home_view'
                            }
                        });
                    }}
                    lazyLoad
                    gestureHandling="cooperative"
                />
            </div>
        </>
    );
};

HomeMap.propTypes = {
    home: PropTypes.instanceOf(Home)
};

const mapStateToProps = (state, ownProps) => ({
    home: state.loadedHomes[ownProps.homeId],
    user: state.user
});

export default connect(mapStateToProps)(HomeMap);
